import api from '../api';


class UsersApi {

    constructor() {
        this.endpoint = {
            user: 'v2/users',
            userv1: 'users',
            signin: 'signin',
            metadata: 'v2/users/meta-data',
            guests: 'guests',
        };
    }

    getById = (userId) => {
        return api.get(this.endpoint.user + '/' + userId, {data: ''});
    }
    
    checkLogin = (login) => {
        return api.request({
            method: 'GET',
            url: `${this.endpoint.user}/exposed/count/login/${login}`,
            data: {},
            headers: {
            'Content-Type' : 'application/json',
            'Accept': 'application/json;charset=UTF-8'
        }
        });
    }

    getMetadataById = userId => {
        return api.get(`${this.endpoint.metadata}/${userId}`, {data: ''});
    }

    userRegister = (body,token) => {
        return api.post(`${this.endpoint.guests}/register/${token}`, body);
    }


}

const instance = new UsersApi();

export default instance;